// BOS_BASE_URL = "https://www.fastdoc.net";
// CHAT_BASE_URL = "https://www.fastdoc.net";
// const BOS_URL= "https://www.fastdoc.net/bos";


const resolveBaseUrl = (url, defaultBaseUrl) => {
    if (url.startsWith("__") && url.endsWith("__")) {
        return defaultBaseUrl;
    }
    return url
}

let BOS_BASE_URL = "__BOS_BASE_URL__"
let CHAT_BASE_URL = "__CHAT_BASE_URL__"

// `npm run start:remote` proxies /bos and /_matrix through the dev server (see setupProxy.js).
// The NODE_ENV check lets production builds strip this out entirely.
const useDevProxy = process.env.NODE_ENV === "development" && process.env.REACT_APP_USE_DEV_PROXY === "true";

BOS_BASE_URL = resolveBaseUrl(BOS_BASE_URL, useDevProxy ? window.location.origin : "http://localhost:9093");
CHAT_BASE_URL = resolveBaseUrl(CHAT_BASE_URL, useDevProxy ? window.location.origin : "http://localhost:8008");



const BOS_URL= `${BOS_BASE_URL}/bos`;
console.log("BOS_URL", BOS_URL);



const PmsUrlConfig = {
   
    HOME_URL : "/",
    SIGN_UP_URL : "/signup",
    SIGN_UP_CONFIMATION_URL: "/signupConf",
    LOGIN_URL : "/login",
    WELCOME_URL : "/welcome",
    VIEW_APPOINTMENTS_FOR_PRACTICE : "/viewAppointments",
    SUBMIT_APPOINTMENT : "/submitAppointment",
    ADD_SERVICE_LOCATION : "/addServiceLocation",
    ADD_SERVICE_LOCATION_CONFIRMATION: "/addServiceLocationConf",
    ADD_USER_URL: "/addUser",
    EDIT_PROFILE_URL: "/editProfile",
    VIEW_USER_APPOINTMENT: "/viewAppointmentsForUser",
    FORGOT_PASSWORD_URL: "/forgotPassword",
    VERIFY_CODE_URL: "/verifyCode",
    CHANGE_PASSWORD_URL: "/changePassword",

    VIEW_USERS: "/viewUsers",
    VIEW_SERVICE_LOCATIONS: "/viewServices",
    SETTINGS: "/settings",
    APPOINTMENTS: "/appointments",
    CHATS: "/chats",
    HEALTH_CHECK_URL: "/health",



    BOS_LOGIN_SERVICE_URL : BOS_URL+"/login",
    BOS_ENTITY_SIGN_UP_URL : BOS_URL+"/register-practice",
    BOS_GET_PRACTICE_AGREEMENT_URL: BOS_URL+"/practice/agreement",
    BOS_GET_PATIENT_AGREEMENT_URL: BOS_URL+"/patient/agreement",
    BOS_ADD_PATIENT_URL: BOS_URL+"/user/addPatient",
    BOS_GENERATE_CODE_URL: BOS_URL+"/user/forgotPassword/generateCode",
    BOS_VERIFY_CODE_URL: BOS_URL+"/user/forgotPassword/verifyCode",

    BOS_EDIT_PRACTICE_URL: BOS_URL+"/practice/edit",
    BOS_ADD_USER_URL: BOS_URL+"/practice/user/addUser/id/",
    BOS_GENERATE_USERNAME: BOS_URL+"/practice/user/validateName/",
    BOS_EDIT_USER_URL: BOS_URL+"/practice/user/editUser",
    BOS_EDIT_PATIENT_PROFILE_URL: BOS_URL+"/patient/user/update",
    BOS_DELETE_ASSOCIATE_URL: BOS_URL+"/associate",
    BOS_DELETE_PATIENT_ACCOUNT_URL: BOS_URL+"/patient",

    BOS_ADD_SERVICE_URL: BOS_URL+"/practice/addServiceLocation/id/",
    BOS_EDIT_SERVICE_URL: BOS_URL+"/practice/editServiceLocation/id/",
    BOS_DELETE_SERVICE_URL: BOS_URL+"/practice/deleteServiceLocation/id/",

    BOS_GET_PRACTICE_UPDATES_URL: BOS_URL+"/practice/id/",
    BOS_GET_SERVICE_TYPES_URL: BOS_URL+"/practice/getServiceTypes",

    BOS_FETCH_APPOINTMENT_FOR_SERVICE_URL: BOS_URL+"/appointment/service/fetchList/id/",
    BOS_FETCH_APPOINTMENTS_FOR_PATIENT_URL: BOS_URL+"/appointment/user/fetchList/id/",
    BOS_FETCH_APPOINTMENT_BY_ID_FOR_PATIENT_URL: BOS_URL+"/appointment/forPatient/fetch/id/",
    BOS_FETCH_APPOINTMENTS_BY_FILTER_URL: BOS_URL+"/appointment/filter/fetch",
    
    BOS_PATIENT_PIN_APPOINTMENT_URL: BOS_URL+"/appointment/patient/pin/id/", 
    BOS_PATIENT_ARCHIVE_APPOINTMENT_URL: BOS_URL+"/appointment/archive/id/",   //TODO:

    BOS_FETCH_SYSTEM_CONSTANTS_URL: BOS_URL+"/system/constants/fetch",
    
    
    BOS_SUBMIT_APPOINTMENT_REQUEST_URL: BOS_URL+"/appointment/request/submit",  
    BOS_UPDATE_APPOINTMENT_URL: BOS_URL+"/appointment/update",
    BOS_ACCEPT_APPOINTMENT_URL: BOS_URL+"/appointment/accept/id/",
    BOS_DELETE_APPOINTMENT_URL: BOS_URL+"/appointment/delete/id/",
    BOS_GET_APPOINTMENT_COUNT_URL: BOS_URL+"/appointment/service/check-new-appointments",
    BOS_JOIN_CHAT_ROOM: BOS_URL+"/appointment/join/id/",
    BOS_SUBMIT_APPOINTMENT_AUDIT_URL: BOS_URL+"/appointment/", 
    BOS_SEND_SUPPORT_MESSAGE_URL: BOS_URL+"/send/support/message",
    MATRIX_HOME_SERVER_URL: `${CHAT_BASE_URL}`,
    MATRIX_SYNAPSE_SERVER_URL: `${CHAT_BASE_URL}`
}


export default PmsUrlConfig